import moment from "moment";
class employedSchedule {
  constructor(
    scheduleId,
    name,
    from,
    to,
    segmId,
    segmento,
    segmDespl,
    numSecuencia
  ) {
    this.scheduleId = scheduleId;
    this.name = name;
    this.from = moment(from).utc().format("DD-MM-YYYY");
    this.to = to == null ? " " : moment.utc(to).format("DD-MM-YYYY");
    this.segmId = segmId;
    this.segmento = segmento;
    this.segmDespl = segmDespl;
    this.numSecuencia = numSecuencia;
  }
  static fromJson({
    horarioId,
    nombre,
    fecDesde,
    fecHasta,
    segmId,
    segmento,
    segmDespl,
    numSecuencia,
  }) {
    return new employedSchedule(
      horarioId,
      nombre,
      fecDesde,
      fecHasta,
      segmId,
      segmento,
      segmDespl,
      numSecuencia
    );
  }
}
export default employedSchedule;
